import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChatInterface from './components/ChatInterface';
import SpotifyTest from './components/SpotifyTest';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ChatInterface />} />
          <Route path="/spotify-test" element={<SpotifyTest />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
